import {
  FetchMyReceivedQuotationsQuery,
  useFetchMyReceivedQuotationsLazyQuery
} from '@generated/graphql';
import { ReactNode, useEffect } from 'react';

interface ChildrenProps {
  refetch: () => void;
  data: FetchMyReceivedQuotationsQuery['fetchMyReceivedQuotations']['data'];
}

interface Props {
  rfqId?: string;
  expanded: boolean;
  children: (props: ChildrenProps) => ReactNode;
}

const AccordionProvider = ({ rfqId, expanded, children }: Props) => {
  const [
    fetchReceivedQuotationsInfo,
    { data, refetch, stopPolling, startPolling }
  ] = useFetchMyReceivedQuotationsLazyQuery({
    variables: {
      input: {
        rfqId: rfqId ?? ''
      }
    },
    fetchPolicy: 'network-only'
  });

  useEffect(() => {
    if (expanded) {
      fetchReceivedQuotationsInfo();
    }
  }, [expanded, fetchReceivedQuotationsInfo]);

  useEffect(() => {
    if (expanded) {
      startPolling(3000);
    }

    if (!expanded) {
      stopPolling();
    }
    return () => {
      stopPolling();
    };
  }, [expanded, stopPolling, startPolling]);

  const quotations = data?.fetchMyReceivedQuotations.data ?? [];

  return <>{children({ data: quotations, refetch })}</>;
};

export default AccordionProvider;
